import React from 'react'

import styles from './styles.module.css'

export const ContentTerms = ({contentTabs, setRadio}) => {
  const {numberOfTabs, tabs, isTermsTitle} = contentTabs
  const handleRadioButton = () => {
    const radioHtml = []
    for (let i = 0; i < numberOfTabs; i++) {
      radioHtml.push(
        <input type="radio" id={`tab${i + 1}`} name="tabControl" defaultChecked={tabs[i].checked} />
      )
    }
    return radioHtml
  }
  const handleTab = () => {
    const tabHtml = []
    for (let i = 0; i < numberOfTabs; i++) {
      const titleLi = tabs[i].name === 'Justo' ? tabs[i].name : 'Company'
      tabHtml.push(
        <li title={titleLi} onClick={() => setRadio(titleLi)}>
          <label htmlFor={`tab${i + 1}`} role="button">
            <img src={tabs[i].urlImage} alt={`Logo de ${tabs[i].name}`} />
            <br />
            <span>{tabs[i].name}</span>
          </label>
        </li>
      )
      if (numberOfTabs === 1) {
        tabHtml.push(
          <li>
            <label htmlFor="tab2" role="button"></label>
          </li>
        )
      }
    }
    return tabHtml
  }

  const handleSection = () => {
    const sections = []
    for (let i = 0; i < numberOfTabs; i++) {
      sections.push(<section>{tabs[i].content}</section>)
    }
    return sections
  }

  return (
    <>
      <p className={styles.titleTyC}>
        {isTermsTitle ? (
          <>
            <b>Términos</b> y Condiciones de uso
          </>
        ) : null}
      </p>
      <div className={styles.content}>
        <div className={styles.tabs}>
          {handleRadioButton()}
          <ul className={styles.ulTabs}>{handleTab()}</ul>
          <div className={styles.slider}>
            <div className={styles.indicator}></div>
          </div>
          <div className={styles.contentTab}>{handleSection()}</div>
        </div>
      </div>
    </>
  )
}
